import React from "react";
import { DotsLoader } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

const SectionLoader = ({ className }) => {
  return (
    <div
      className={classNames("tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full", className)}
      data-testid="section-loader"
    >
      <DotsLoader />
    </div>
  );
};

SectionLoader.propTypes = {
  className: PropTypes.string,
};

export default SectionLoader;
